import React, { useEffect, useMemo } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './theme/globalStyles';
import theme from './theme/mainTheme';
import { Provider } from 'react-redux';
import { persistor, store } from './redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import { getRoutesMain, paths } from './routes';
import PrivateRoute from './routes/PrivateRoute';
import Dashboard from './pages/Dashboard';
import Api from './api/Api';
import RouteTitle from './routes/RouteTitle';
import { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl";
import { useTranslation } from 'react-i18next';
import Lang from './api/Lang';
import Currency from './api/Currency';

const App = () => {
  const { t } = useTranslation()
  useEffect(() => {
    registerLocale("pl", pl);
  }, []);

  const routesMain = useMemo(() => getRoutesMain(), []);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <Lang />
            <Api />
            <Switch>
              {/* PUBLIC */}
              {
                routesMain && Object.values(routesMain).map(route => (
                  <RouteTitle title={t(route.name)} exact={route.exact} path={route.path} component={route.component} key={route.path} />
                ))
              }
              <Route
                path="/email-confirmation"
                render={props => (
                  <Redirect to={`${paths.emailConfirmation}${props.location.search}`} />
                )}
              />
              <Route
                path="/reset-password"
                render={props => (
                  <Redirect to={`${paths.resetPassword}${props.location.search}`} />
                )}
              />
              {/* PRIVATE */}
              <PrivateRoute path={paths.home}>
                <Currency/>
                <Dashboard />
              </PrivateRoute>
            </Switch>
          </Router>
        </PersistGate>
      </Provider>
      <ToastContainer />
    </ThemeProvider>
  );
}

export default App;
